// 認証情報をクリアするヘルパー関数
export const clearAuthData = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_info');
  console.log('Auth data cleared. Please refresh and login again.');
};

// ブラウザコンソールで使用可能にする
window.clearAuthData = clearAuthData;